<template>
  <div class="tag">
    <a
      :href="`/blog/tag/${tag.translation.slug}`"
    >#{{ tag.translation.name.toLowerCase() }}</a>
  </div>
</template>
<script>
export default {
  name: 'Tag',
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    tag: {
      get() {
        return this.value;
      },
      set(tag) {
        this.$emit('input', tag);
      },
    },
  },
};
</script>

<style scoped>
.tag {
  background-color: #efefef;
  padding: .3rem;
  color: var(--blog-text);
  border-radius: 5px;
  margin: 5px;
}
.tag a {
  color: var(--blog-text);
  text-decoration: none;
  font-size: 1.1rem;
}
.tag a:hover{
  color: var(--blog-link);
}
</style>
